import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';
import gu from './gu.json';
import hi from './hi.json';

const STORAGE_KEY = 'vipso.language';

export type AppLanguage = 'en' | 'gu' | 'hi';

export function getStoredLanguage(): AppLanguage {
  const raw = typeof localStorage !== 'undefined' ? localStorage.getItem(STORAGE_KEY) : null;
  if (raw === 'gu' || raw === 'hi' || raw === 'en') return raw;
  return 'en';
}

export function setStoredLanguage(lang: AppLanguage) {
  localStorage.setItem(STORAGE_KEY, lang);
  void i18n.changeLanguage(lang);
}

void i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    gu: { translation: gu },
    hi: { translation: hi },
  },
  lng: getStoredLanguage(),
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

export default i18n;
